import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from 'react'

const ONBOARDING_KEY = 'onboarding_completed'

interface OnboardingContextType {
  isCompleted: boolean | null
  completeOnboarding: () => void
  resetOnboarding: () => void
}

const OnboardingContext = createContext<OnboardingContextType | undefined>(
  undefined,
)

interface OnboardingProviderProps {
  children: ReactNode
}

export const OnboardingProvider: React.FC<OnboardingProviderProps> = ({
  children,
}) => {
  const [isCompleted, setIsCompleted] = useState<boolean | null>(null)

  // Инициализация состояния из localStorage при загрузке
  useEffect(() => {
    const completed = localStorage.getItem(ONBOARDING_KEY) === 'true'
    setIsCompleted(completed)
  }, [])

  const completeOnboarding = () => {
    localStorage.setItem(ONBOARDING_KEY, 'true')
    setIsCompleted(true)
  }

  const resetOnboarding = () => {
    localStorage.removeItem(ONBOARDING_KEY)
    setIsCompleted(false)
  }

  const value: OnboardingContextType = {
    isCompleted,
    completeOnboarding,
    resetOnboarding,
  }

  return (
    <OnboardingContext.Provider value={value}>
      {children}
    </OnboardingContext.Provider>
  )
}

export const useOnboardingContext = () => {
  const context = useContext(OnboardingContext)

  if (context === undefined) {
    throw new Error(
      'useOnboardingContext must be used within an OnboardingProvider',
    )
  }
  return context
}
